import type { Export } from '../settings/useExport';
import type { FileIntake } from './useFileIntake';

/**
 * The quiet strips between the heading and the grid: photos arriving, a file
 * that couldn't be read, a backup written or refused.
 *
 * All four read the same way — paper, no colour, the way out on the right —
 * because they're all the same kind of thing: something the board is briefly
 * in the middle of. `--oxblood` is for deletions and nothing else.
 */
export function BoardNotices({ intake, exporter }: { intake: FileIntake; exporter: Export }) {
  return (
    <>
      {intake.adding > 0 && (
        <p className="board__notice" role="status">
          Adding {intake.adding} {intake.adding === 1 ? 'photo' : 'photos'}…
        </p>
      )}

      {intake.error !== undefined && (
        <Notice tone="alert" onDismiss={intake.dismissError}>
          {intake.error}
        </Notice>
      )}

      {exporter.error !== undefined && (
        <Notice tone="alert" onDismiss={exporter.dismiss}>
          {exporter.error}
        </Notice>
      )}

      {exporter.saved !== undefined && (
        <Notice tone="status" onDismiss={exporter.dismiss}>
          Saved as {exporter.saved}.
        </Notice>
      )}
    </>
  );
}

function Notice({
  tone,
  onDismiss,
  children,
}: {
  tone: 'status' | 'alert';
  onDismiss: () => void;
  children: React.ReactNode;
}) {
  return (
    <p className="board__notice" role={tone}>
      {children}
      <button type="button" className="board__dismiss" onClick={onDismiss}>
        Dismiss
      </button>
    </p>
  );
}
